import React, { useEffect } from 'react';
import styled from 'styled-components';

import Login from '../../components/templates/auth/Login';
import PublicityWithout from '../../components/templates/auth/PublicityWithout';
import WhatsappBtn from '../../components/common/WhatsappBtn';

const LoginPage = () => {
    useEffect(() => {
        localStorage.clear();
    }, []);

    return (
        <LoginPageContainer>
            <PublicityWithout />
            <Login />
            <WhatsappBtn x="right: 7rem" y="bottom: 1.5rem" />
        </LoginPageContainer>
    );
};

export default LoginPage;

const LoginPageContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    height: 100vh;

    @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        div {
            height: 100%;
        }
    }
`;
